import { getUploadPolicy } from '../services/transcriptionService';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Auth from '../services/auth';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Notifications from '@material-ui/icons/Notifications';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import NativeSelect from '@material-ui/core/NativeSelect';
import PubSub from 'pubsub-js';
import Badge from '@material-ui/core/Badge';
import TextField from '@material-ui/core/TextField';
import { withRouter } from "react-router-dom";
import compose from 'recompose/compose';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import Hidden from '@material-ui/core/Hidden';
import Snackbar from '@material-ui/core/Snackbar';
import ReactGA from 'react-ga4';
import Alert from './Alert';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HelpIcon from '@material-ui/icons/Help';
import DashboardIcon from '@material-ui/icons/Dashboard';
import TodayIcon from '@material-ui/icons/Today';
import ViewListOutlined from '@material-ui/icons/ViewList';
import DescriptionIcon from '@material-ui/icons/Description';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import PeopleIcon from '@material-ui/icons/People';
import SettingsIcon from '@material-ui/icons/Settings';
import TuneIcon from '@material-ui/icons/Tune';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SettingsDataAccess from '../services/settingsDataAccess';
import moment from 'moment';

const drawerWidth = 240;
const auth = new Auth();

// Visible only when the Transcription policy for the selected account allows upload
// (global switch on and account opted in).
const isTranscriptionEnabled = result => !!(result && result.data && Array.isArray(result.data.Policies)
    && result.data.Policies.some(p => p && p.Workflow === 'Transcription' && p.UploadEnabled === true));
const settingsDataAccess = new SettingsDataAccess();

export const styles = theme => ({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        minHeight: '100vh',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    drawerFooter: {
        marginTop: 'auto',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        width: 'calc(100% - 71px)'
    },
    splashContent: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        width: 'calc(100% - 71px)'
    },
    flex: {
        flex: 1,
    }, selectEmpty: {
        maxWidth: '500px',
        marginTop: theme.spacing(2),
        fontSize: '1.3125rem',
        color: '#fff',
        '&::before': {
            borderBottom: '1px solid #fff !important'
        },
        '&::focus': {
            borderBottom: '1px solid #fff !important'
        },
        '& option': {
            color: '#000'
        }
    },
    selectIcon: {
        color: '#fff'
    }, badgeMargin: {
        margin: theme.spacing(1),
    },
    accountWrapper: {
        flex: 1,
        marginTop: (theme.spacing(2)) * -1
    },
    SNBrand: {
        color: theme.palette.secondary.main
    },
    input: {
        color: '#fff',
        background: 'rgba(255,255,255,0.15)',
        padding: theme.spacing(1),
    },
    gutters: theme.mixins.gutters()
});

class SingleAccount extends React.Component {

    render() {
        const accountName = this.props.accountName;
        return <Typography variant="h6" color="inherit" style={{ marginTop: 16 }} noWrap>{accountName}</Typography>;
    }
}



class MultiAccount extends React.Component {


    handleChange = (event) => {

        this.props.onAccountChange(event);
    }

    render() {
        const accounts = this.props.userAccounts;
        const classes = this.props.classes;

        return (<NativeSelect name="account" defaultValue={auth.getActiveAccount()} onChange={this.handleChange} className={classes.selectEmpty} classes={{
            icon: classes.selectIcon
        }}
        >
            {
                accounts.map(function (a) {
                    return <option key={a.Account}
                        value={a.Account}>{a.Facility}</option>;
                })
            }
        </NativeSelect>);
    }
}

export class AccountSelector extends React.Component {

    render() {
        const canSwitch = this.props.canSwitch;
        const accountName = this.props.accountName;
        const userAccounts = this.props.userAccounts;

        if (canSwitch === "true") {
            return <MultiAccount userAccounts={userAccounts} onAccountChange={this.props.onAccountChange} classes={this.props.classes} />;
        }
        return <SingleAccount accountName={accountName} />;
    }
}


class NotificationBadge extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null,
            //anchorNotificiationEl: null,
            menuOpenNotification: false,
            menuOpen: false,
            notifications: []
        };

        var self = this;
        auth.getNotifications().then(function (data) {
            self.setState({ notifications: data });
        });
    }
    handleNotificationClose = () => {

        var notifications = this.state.notifications;

        notifications = auth.markNotificationsRead(notifications);
        this.setState({ anchorEl: {}, menuOpenNotification: false, notifications: notifications });


    };


    handleNotificationMenu = (event) => {
        this.setState({ anchorEl: event.currentTarget, menuOpenNotification: true });
    };

    render() {

        const { notifications } = this.state;
        const notificationCount = notifications ? notifications.length : 0;
        let unReadCount = 0;

        for (var i = 0; i < notifications.length; i++) {
            if (notifications[i].IsRead !== true) {
                unReadCount++;
            }
        }



        return <div>{notificationCount === 0 && (
            <IconButton disabled
                color="inherit">

                <Notifications />

            </IconButton>)}
            {notificationCount > 0 && (
                <div><IconButton aria-owns={this.state.openNotification ? 'menu-notification' : null}
                    aria-haspopup="true"
                    onClick={this.handleNotificationMenu}
                    color="inherit" style={{ overflow: 'visible' }}>
                    {unReadCount > 0 && <Badge badgeContent={unReadCount} color="secondary">
                        <Notifications />  </Badge>}
                    {unReadCount === 0 &&
                        <Notifications />}

                </IconButton>
                    <Menu id="menu-notification"
                        anchorEl={this.state.anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={this.state.menuOpenNotification}
                        onClose={this.handleNotificationClose}

                    >
                        {notifications.map(msg => {
                            return (
                                <MenuItem key={msg} href={msg.Url} target='_blank' name={msg.NotificationId} onClick={e => (ReactGA.event({
                                    action: 'NotificationClick',
                                    category: `${auth.getGaUser()}_${msg.NotificationId}`
                                }))} component='a' style={{ whiteSpace: 'normal', height: 'auto', width: 300 }}>
                                    {msg.Title}
                                </MenuItem>
                            )
                        })}
                    </Menu></div>)}
        </div>

    }
}

export class GlobalDrawer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            anchorEl: null,
            menuOpen: false,
            search: '',
            openSnack: false,
            canShowPwdAlert: true,
            viewDocumentUpload: true,
            // Opt-in (unlike DisableDocumentUpload's opt-out), so this defaults hidden until the
            // account setting confirms it's on -- never shown-then-hidden for a disabled account.
            viewTranscriptionUpload: false,
        };

    }

    async componentWillMount() {
        await auth.setIsCoding(auth.getActiveAccount());
        await this.checkCanViewDocumentUpload();
        await this.checkCanViewTranscriptionUpload();
        this.token = PubSub.subscribe('AppUpdated', this.appUpdated.bind(this));
    }
    componentWillUnmount() {
        this.transcriptionCheckVersion = (this.transcriptionCheckVersion || 0) + 1;
        PubSub.unsubscribe(this.token);
    }

    appUpdated(msg, data) {
        this.setState({ openSnack: true });
    }

    handleDrawerOpen = () => {
        this.setState({ open: true });
    };

    handleDrawerClose = () => {
        this.setState({ open: false });
    };

    handleClose = () => {

        this.setState({ anchorEl: {}, menuOpen: false });
    };


    handleLogOut = () => {

        const auth = new Auth();
        auth.signOut();
    }

    handleChangePassword = () => {

        this.props.history.push('/changePassword');
    }

    handleMenu = (event) => {
        this.setState({ anchorEl: event.currentTarget, menuOpen: true });
    };

    checkCanViewDocumentUpload = async () => {
        let result = await settingsDataAccess.getAccountSettingsBySettingsName("DisableDocumentUpload");
        let isViewDocumentUploadDisabled = result && result.data && result.data.Id > 0 && result.data.SettingValue == "1";
        auth.setCanViewDocumentUpload(!isViewDocumentUploadDisabled);
        this.setState({ viewDocumentUpload: !isViewDocumentUploadDisabled });
    };

    checkCanViewTranscriptionUpload = async () => {
        const version = this.transcriptionCheckVersion = (this.transcriptionCheckVersion || 0) + 1;
        const account = auth.getActiveAccount();
        this.setState({ viewTranscriptionUpload: false });
        // Transcription Upload is for home-account 998 users only, on accounts where it is enabled.
        if (auth.getHomeAccount() !== '998') return;
        try {
            let result = await getUploadPolicy(account);
            if (version !== this.transcriptionCheckVersion || account !== auth.getActiveAccount()) return;
            let isTranscriptionUploadEnabled = isTranscriptionEnabled(result);
            this.setState({ viewTranscriptionUpload: isTranscriptionUploadEnabled });
        } catch (error) {
            if (version !== this.transcriptionCheckVersion || account !== auth.getActiveAccount()) return;
            this.setState({ viewTranscriptionUpload: false });
        }
    };

   setAccountDefaultFromDate = async () => {
        function isInteger(str) {
            const num = parseFloat(str);
            return !isNaN(num) && Number.isInteger(num);
        }

        let result = await settingsDataAccess.getAccountSettingsBySettingsName("DefaultSnChartFromDateOffset");
       if (result && result.data && result.data.Id > 0 && isInteger(result.data.SettingValue)) {
           auth.setFromDate(moment().subtract(result.data.SettingValue, 'days').format("MM/DD/YYYY"));
       }
       else {
           auth.setFromDate(moment().subtract('30', 'days').format("MM/DD/YYYY"));

       }
    }

    handleAccountChange = async (event) => {
        const auth = new Auth();
        const { value } = event.target;
        auth.setActiveAccount(value);
        this.transcriptionCheckVersion = (this.transcriptionCheckVersion || 0) + 1;
        this.setState({ viewTranscriptionUpload: false });
        // Invalidate uploads synchronously; other listeners retain the established ready event.
        PubSub.publishSync('AccountChanging', value);
        try {
            await auth.setIsCoding(value);
            if (auth.getActiveAccount() !== value) return;
            await this.checkCanViewDocumentUpload();
            if (auth.getActiveAccount() !== value) return;
            await this.checkCanViewTranscriptionUpload();
            await this.setAccountDefaultFromDate();
        } finally {
            if (auth.getActiveAccount() === value) PubSub.publish('AccountChanged', value);
        }
    };

    search = (event) => {
        event.preventDefault();

        if (this.state.search && this.state.search !== '') {
            this.props.history.push(`/reports/search/${this.state.search}`);
        }
    };

    handleChange = (event) => {

        const { target: { name, value } } = event;
        this.setState({ [name]: value });
    }

    handleSnackClose = () => {
        this.setState({ openSnack: false });
    }

    handleAlertClose = () => {

        this.setState({ canShowPwdAlert: false });
    }

    handleAlertOk = () => {

        this.setState({ canShowPwdAlert: false });
        this.props.history.push(`/changePassword`);
    }

    render() {
        const { classes, theme } = this.props;
        const auth = new Auth();
        const userName = auth.getUserName();
        const centerName = auth.getCenterName();
        const isCodingAccount = auth.getIsCoding();
        const canSwitchAccounts = auth.canSwitchAccounts();
        const userAccounts = auth.getUserAccounts();
        const isAuthenticated = auth.isAuthenticated() && auth.isValidLogin();
        const passwordExpiresIn = auth.getPasswordExpiresIn();
        const ssoIdentityColumn = auth.getSSOIdentityColumn();
        const showPasswordAlert = this.state.canShowPwdAlert && isAuthenticated && (passwordExpiresIn <= 7 && !auth.isPasswordExpired());    
        return (
            <div className={classes.root}>
                <Alert showAlert={showPasswordAlert}
                    alertText={`Your password will expire in ${passwordExpiresIn} day(s).`}
                    alertTitle={'Your password is about to expire'}
                    alertOkText={'Change Password'}
                    alertCancelText={'Not now'}
                    onAlertCancel={this.handleAlertClose}
                    onAlertOk={this.handleAlertOk}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    open={this.state.openSnack}
                    onClose={this.handleSnackClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">A new version of the app is available</span>}
                    action={<Button color="secondary" onClick={(e) => { window.location.reload(true) }} className={classes.snackButton}>Refresh</Button>}

                />
                <AppBar
                    position="absolute"
                    className={classNames(classes.appBar, this.state.open && classes.appBarShift)}
                >
                    <Toolbar disableGutters={!this.state.open && isAuthenticated}>
                        {isAuthenticated && <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={this.handleDrawerOpen}
                            className={classNames(classes.menuButton, this.state.open && classes.hide)}
                        >
                            <MenuIcon />
                        </IconButton>}
                        <Typography variant="h6" color="inherit" noWrap>
                            <span className={classes.SNBrand}>SN</span>Chart  {isAuthenticated && <span> - &nbsp;</span>}
                        </Typography>
                        {isAuthenticated && (<span className={classes.accountWrapper}><AccountSelector canSwitch={canSwitchAccounts} accountName={centerName} userAccounts={userAccounts} onAccountChange={this.handleAccountChange} classes={classes} />
                        </span>)}

                        {isAuthenticated && (

                            <div>

                                <Grid container spacing={2} alignItems="flex-end">
                                    <Hidden xsDown={true}><Grid item>
                                        <form onSubmit={this.search}>
                                            <TextField

                                                name="search"
                                                id="search"
                                                placeholder="Go to any report..."
                                                autoComplete="off"
                                                type="search"

                                                onChange={this.handleChange}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                                                    disableUnderline: true,
                                                    className: classes.input,

                                                }}

                                            /></form>
                                    </Grid></Hidden>
                                    <Grid item>
                                        <NotificationBadge />
                                    </Grid>
                                    <Grid item>
                                        <IconButton
                                            aria-owns={this.state.open ? 'menu-appbar' : null}
                                            aria-haspopup="true"
                                            onClick={this.handleMenu}
                                            color="inherit"
                                        >

                                            <AccountCircle />
                                        </IconButton>
                                        <Menu
                                            id="menu-appbar"
                                            anchorEl={this.state.anchorEl}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            open={this.state.menuOpen}
                                            onClose={this.handleClose}
                                        >
                                            <MenuItem>{userName}</MenuItem>
                                            { ssoIdentityColumn === '' && <MenuItem onClick={this.handleChangePassword}>Change Password</MenuItem>}
                                            <MenuItem onClick={this.handleLogOut}>Log out</MenuItem>

                                        </Menu>
                                    </Grid>
                                </Grid>


                            </div>
                        )}
                    </Toolbar>
                </AppBar>
                {isAuthenticated && <Drawer
                    variant="permanent"
                    classes={{
                        paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
                    }}
                    open={this.state.open}
                >
                    <div className={classes.toolbar}>
                        <IconButton onClick={this.handleDrawerClose}>
                            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                        </IconButton>
                    </div>
                    <Divider />
                    <List>
                        <div>
                            <Tooltip title="Dashboard" placement="right" disableFocusListener>
                                <ListItem button component={Link} to='/' classes={{ gutters: classNames(classes.gutters) }}>
                                    <ListItemIcon>
                                        <DashboardIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Dashboard" />
                                </ListItem>
                            </Tooltip>
                            <Tooltip title="Schedule" placement="right" disableFocusListener>
                                <ListItem button component={Link} to='/schedule' classes={{ gutters: classNames(classes.gutters) }}>
                                    <ListItemIcon>
                                        <TodayIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Schedule" />
                                </ListItem>
                            </Tooltip>
                            <Tooltip title="Reports" placement="right" disableFocusListener={true}>
                                <ListItem button component={Link} to='/reports' classes={{ gutters: classNames(classes.gutters) }}>
                                    <ListItemIcon>
                                        <ViewListOutlined />
                                    </ListItemIcon>
                                    <ListItemText primary="Reports" />
                                </ListItem>
                            </Tooltip>
                            {auth.isInRole('Support Admin') || isCodingAccount === 'true' && this.state.viewDocumentUpload?
                                (
                                    <Tooltip title="Coding Upload" placement="right" disableFocusListener={true}>
                                        <ListItem button component={Link} to='/document-upload' classes={{ gutters: classNames(classes.gutters) }}>
                                            <ListItemIcon>
                                                <CloudUploadIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Coding Upload" />
                                        </ListItem>
                                    </Tooltip>
                                ) : null
                            }
                            {this.state.viewTranscriptionUpload ?
                                (
                                    <Tooltip title="Transcription Uploads" placement="right" disableFocusListener={true}>
                                        <ListItem button component={Link} to='/transcription-upload' classes={{ gutters: classNames(classes.gutters) }}>
                                            <ListItemIcon>
                                                <DescriptionIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Transcription Uploads" />
                                        </ListItem>
                                    </Tooltip>
                                ) : null
                            }
                            <Tooltip title="Help" placement="right" disableFocusListener={true}>
                                <ListItem button component={Link} to='/help' classes={{ gutters: classNames(classes.gutters) }}>
                                    <ListItemIcon>
                                        <HelpIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Help" />
                                </ListItem>
                            </Tooltip>
                            <Tooltip title="Archive Request" placement="right" disableFocusListener={true}>
                                <ListItem button component={Link}  to="/support-request/archive-request" classes={{ gutters: classNames(classes.gutters) }}>
                                    <ListItemIcon>
                                        <DescriptionIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Support Request Form" />
                                </ListItem>
                            </Tooltip>

                            <Tooltip title="User Management" placement="right" disableFocusListener={true}>
                                <ListItem button component={Link} to='/users' classes={{ gutters: classNames(classes.gutters) }}>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="User Management" />
                                </ListItem>
                            </Tooltip>
                            <Tooltip title="Facility Settings" placement="right" disableFocusListener={true}>
                                <ListItem button component={Link} to='/settings' classes={{ gutters: classNames(classes.gutters) }}>
                                <ListItemIcon>
                                    <SettingsIcon />
                                </ListItemIcon>
                                    <ListItemText primary="Facility Settings" />
                                </ListItem>
                             </Tooltip>
                        </div>
                    </List>
                    {auth.getHomeAccount() === '998' && <div className={classes.drawerFooter}>
                        <Divider />
                        <List>
                            <Tooltip title="Admin" placement="right" disableFocusListener={true}>
                                <ListItem button component={Link} to='/admin' classes={{ gutters: classNames(classes.gutters) }}>
                                    <ListItemIcon>
                                        <TuneIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Admin" />
                                </ListItem>
                            </Tooltip>
                        </List>
                    </div>}
                </Drawer>}
                <main className={(isAuthenticated && classes.content) || (!isAuthenticated && classes.splashContent)}>
                    <div className={classes.toolbar} />
                    {this.props.children}
                </main>
            </div>
        );
    }
}

GlobalDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default compose(withRouter, withStyles(styles, { withTheme: true }))(GlobalDrawer);



// WEBPACK FOOTER //
// ./src/components/GlobalDrawer.js